<template>
  <v-container>
    <v-row class="mx-1">
      <v-spacer></v-spacer>
      <v-btn depressed large @click="newOrder">Nueva Orden</v-btn>
    </v-row>
    <v-row>
      <v-col cols="12">
        <h2>Pedidos</h2>
        <v-row v-if="loadingOrders">
          <v-col sm="12" class="text-center">
            <v-progress-circular
              :size="70"
              :width="7"
              color="black"
              indeterminate
            ></v-progress-circular>
          </v-col>
        </v-row>
        <v-row v-if="!loadingOrders">
          <v-col sm="6" md="3" v-for="(item, index) in orders" :key="index">
            <v-card 
              outline 
              v-ripple 
              shaped
              color="grey lighten-5"
              class="pa-3"
              @click="selectOrder(item)"
            >
              <v-card-text>
                <v-row sm="12">
                  <v-spacer></v-spacer>
                  <div class="caption">{{format(parseISO(item.Fecha), 'HH:mm')}}</div>
                </v-row>
                <v-row>
                  <v-col sm="12">
                    <p>{{item.Estado}}</p>
                    <p class="title">#{{item.Nid}}</p>
                  </v-col>
                </v-row>
                <v-row sm="12" class="mb-1">
                  <v-spacer></v-spacer>
                  <div class="headline">${{item.Total}}</div>
                </v-row>
                <v-row sm="12" class="mb-1">
                  <v-spacer></v-spacer>
                  <div class="caption">{{item.Cliente}}</div>
                 </v-row>
                <v-row sm="12" class="mb-1">
                  <v-spacer></v-spacer>
                  <div class="caption">Asignado a: {{item.Repartidor}}</div>
                </v-row>
                <v-row sm="12">
                  <v-spacer></v-spacer>
                  <div class="caption">Creado por: {{item.Author}}</div>
                </v-row>
              </v-card-text>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-dialog v-model="dialog_pedido" fullscreen hide-overlay>
      <v-card>
        <v-toolbar color="grey lighten-5" flat>
          <v-img 
            alt="Mona Logo" 
            class="shrink mr-2" 
            contain :src="require('../assets/mona_logo.png')" 
            transition="scale-transition" width="50" />
          <v-toolbar-title>Clientes</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="dialog_pedido = false">
            <v-icon color="grey darken-1">mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-card outlined class="mt-5">
            <v-card-title>
              <v-spacer></v-spacer>
              <v-btn text @click="createClienteDialog = true">
                Nuevo
              </v-btn>
            </v-card-title>
            <v-card-text>
              <v-form
                ref="form_search_tel"
                v-model="valid"
                lazy-validation
                v-on:submit.prevent="buscarTelefono"
              >
                <v-text-field
                  v-model="telefono"
                  :rules="required"
                  label="Teléfono"
                  required
                  append-outer-icon="search"
                  @click:append-outer="buscarTelefono"
                  clearable
                ></v-text-field>
              </v-form>
              <!-- Results -->
              <v-row>
                <v-col sm="12" class="px-2" v-if="searchingTel">
                  <v-progress-linear
                    indeterminate
                    color="grey"
                  ></v-progress-linear>
                </v-col>
              </v-row>
              <v-row v-for="item in searchResults" :key="item.nid" class="text-center">
                <v-col md="3" sm="12">
                  <div>{{item.nombre}} {{item.apellidos}}</div>
                  <div class="caption">Nombre</div>
                </v-col>
                <v-col md="3" sm="12">
                  <div>{{item.telefono}}</div>
                   <div class="caption">Teléfono</div>
                </v-col>
                <v-col md="3" sm="12">
                  <div v-if="item.email === null">No proporcionado</div>
                  <div v-else>{{item.email}}</div>
                  <div class="caption">Correo</div>
                </v-col>
                <v-col md="3" sm="12">
                  <div>
                    <v-btn icon color="red lighten-1" @click="selectCliente(item.nid)">
                      <v-icon large>local_pizza</v-icon>
                    </v-btn>
                  </div>
                </v-col>
              </v-row>
              <!-- Results -->
            </v-card-text>
            <v-card-actions>
              
            </v-card-actions>
          </v-card>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- Create Cliente y Dirección -->
    <v-dialog v-model="createClienteDialog" persistent>
      <v-card>
        <v-stepper v-model="clienteStepper" >
          <v-stepper-header class="elevation-0 grey lighten-5">
            <v-stepper-step :complete="clienteStepper > 1" step="1" color="green darken-1">Cliente</v-stepper-step>
      
            <v-divider></v-divider>
      
            <v-stepper-step :complete="clienteStepper > 2" step="2" color="green darken-1">Dirección</v-stepper-step>
         </v-stepper-header>
        
        <v-stepper-items>
          <v-stepper-content step="1">
             <v-card>
              <v-card-text>
                <p class="caption text-center" v-if="phoneNotUnique">El teléfono ya está registrado
                  <span><v-icon medium color="orange darken-2">info</v-icon></span>
                </p>
                <v-form ref="create_cliente_form" v-on:submit.prevent="nextStep">
                  <v-text-field
                    v-model="field_nombre_cli"
                    :rules="required"
                    label="Nombre"
                    required
                  ></v-text-field>
                  <v-text-field
                    v-model="field_apellidos_cli"
                    :rules="required"
                    label="Apellidos"
                    required
                  ></v-text-field>
                  <v-text-field
                    v-model="field_telefono_cli"
                    :rules="required"
                    label="Teléfono"
                    required
                    type="number"
                  ></v-text-field>
                  <v-text-field
                    v-model="field_email_cli"
                    :rules="required"
                    label="Correo"
                    required
                    type="email"
                  ></v-text-field>
                </v-form>
              </v-card-text>
               <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn text @click="saveCliente">Siguiente</v-btn>
                  <v-btn text @click="cancelCliente">Cancelar</v-btn>
                </v-card-actions>
             </v-card>
          </v-stepper-content>
          <v-stepper-content step="2">
            <v-card-text>
              <v-form ref="direccion_form" v-on:submit.prevent="saveDireccion">
                <v-row>
                  <v-col sm="12">
                    <v-text-field
                      v-model="calle"
                      :rules="required"
                      label="Calle y Número"
                      required
                      clearable
                    ></v-text-field>
                  </v-col>
                  <v-col sm="12" md="6">
                    <v-text-field
                      v-model="colonia"
                      :rules="required"
                      label="Colonia"
                      required
                      clearable
                    ></v-text-field>
                  </v-col>
                  <v-col sm="12" md="6">
                    <v-text-field
                      v-model="ciudad"
                      :rules="required"
                      label="Ciudad"
                      required
                      clearable
                    ></v-text-field>
                  </v-col>
                  <v-col sm="12">
                    <v-text-field
                      v-model="observaciones"
                      label="Observaciones"
                      clearable
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text @click="pickupOrder">Para Llevar</v-btn>
              <v-btn text @click="saveDireccion">Guardar</v-btn>
              <v-btn text @click="cancelCliente">Cancelar</v-btn>
            </v-card-actions>
          </v-stepper-content>
        </v-stepper-items>
       </v-stepper>
      </v-card>
    </v-dialog>
    <!-- Create Cliente y Dirección -->
    <!-- Pedido -->
    <v-dialog v-model="pedidoDialog" fullscreen persistent max-width="600px">
      <v-card>
        <v-toolbar color="grey lighten-5" flat>
          <v-img 
            alt="Mona Logo" 
            class="shrink mr-2" 
            contain :src="require('../assets/mona_logo.png')" 
            transition="scale-transition" width="50" />
          <v-toolbar-title>Seleccionar Dirección</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="pedidoDialog = false">
            <v-icon color="grey darken-1">mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-row v-if="loadingDirecciones">
            <v-col sm="12" class="px-2">
              <v-progress-linear
                indeterminate
                color="grey"
              ></v-progress-linear>
            </v-col>
          </v-row>
          <v-row class="text-center" v-if="direcciones.length == 0 && loadingDirecciones == false">
            <v-col>
              <p class="caption">El cliente no tiene dirección asignada.</p>
            </v-col>
          </v-row>
          <section v-if="!loadingDirecciones && selectedCliente != null">
            <v-row>
              <v-col class="text-center">
                <p class="title">Cliente</p>
              </v-col>
            </v-row>
            <v-row class="text-center">
              <v-col sm="12" md="4">
                {{selectedCliente.field_nombre_cli.und[0].value}}
                <p class="caption">Nombre</p>
              </v-col>
              <v-col sm="12" md="4">
                {{selectedCliente.field_apellidos_cli.und[0].value}}
                <p class="caption">Apellido</p>
              </v-col>
              <v-col sm="12" md="4">
                {{selectedCliente.field_telefono_cli.und[0].value}}
                <p class="caption">Teléfono</p>
              </v-col>
            </v-row>
            <v-divider></v-divider>
            <v-row class="ma-2">
              <v-spacer></v-spacer>
              <v-btn text>Nueva Dirección</v-btn>
            </v-row>
            <v-row>
              <v-col class="text-center">
                <p class="title">Direcciones</p>
              </v-col>
            </v-row>
            <v-row v-for="item in direcciones" :key="item.nid" class="text-center">
              <v-col sm="12" md="3">
                {{item.calle}}
                <p class="caption">Calle</p>
              </v-col>
              <v-col sm="12" md="3">
                {{item.colonia}}
                <p class="caption">Colonia</p>
              </v-col>
              <v-col sm="12" md="3">
                {{item.ciudad}}
                <p class="caption">Ciudad</p>
              </v-col>
              <v-col md="3" sm="12">
                <div>
                  <v-btn icon @click="selectAddress(item)">
                    <v-icon large>home</v-icon>
                  </v-btn>
                </div>
              </v-col>
            </v-row>
          </section>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="pedidoDialog = false">Siguiente</v-btn>
          <v-btn text @click="pedidoDialog = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Pedido -->
    <Loader :showLoader="showLoader"/>
    <Pedido v-if="$store.state.dialog_pedido" :selected_client_nid="selected_client_nid" @orderCompleted="orderCompleted"/>
    <!-- Orden -->
    <v-dialog
      v-model="orderDialog"
      persistent
      max-width="500px"
      transition="dialog-transition"
    >
      <v-card v-if="selectedOrder != null">
        <v-card-title>
          {{selectedOrder.Cliente}}
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col sm="12" v-if="!statusUpdate" @click="statusUpdate = true">
              {{selectedOrder.Estado}}
              <p class="caption">Estado</p>
            </v-col>
            <v-col sm="8" v-if="statusUpdate">
              <v-select
                v-model="selectedEstado"
                :items="procesos"
                label="Proceso"
                item-text="key"
                item-value="value"
              ></v-select>
            </v-col>
            <v-col sm="4" v-if="statusUpdate">
              <v-btn color="success" icon class="ma-5" @click="updateStatus(selectedOrder)">
                <v-icon>mdi-check</v-icon>
              </v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col sm="12">
              #{{selectedOrder.Nid}}
              <p class="caption">Orden</p>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="orderDialog = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Orden -->
  </v-container>
</template>

<script>
import axios from 'axios'
//import db from '../db.js'
import functions from '@/mixins/functions'
import Loader from '../components/Loader'
import Pedido from '@/components/Pedido'
import {mapGetters} from 'vuex'
import format from 'date-fns/format'
import parseISO from 'date-fns/parseISO'
import Pusher from 'pusher-js' // import Pusher

const pusher = new Pusher('a3066e9e2d1ba9dbb8a4', { cluster: 'us3' })
const channel = pusher.subscribe('orders')

export default {
    name: 'Dashboard',
    mixins: [
      functions
    ],
    components: {
      Loader,
      Pedido
    },
    data() {
      return {
        format,
        parseISO,
          search: '',
          dialog_pedido: false,
          valid: true,
          required: [
            v => !!v || 'Campo Requerido'
          ],
          table_headers: [
              {text: 'Nombre',value: 'name'},
                {text: 'Guía', value: 'calories'},
                {text: 'Estado',value: 'fat'
                },
                {
                    text: 'Tipo de Entrega',
                    value: 'carbs'
                },
                {
                    text: 'Hora',
                    value: 'protein'
                },
                {
                    text: 'Dirección',
                    value: 'iron'
                },
                {
                    text: 'Teléfono',
                    value: 'telefono'
                },
                {
                    text: 'Precio',
                    value: 'precio'
                },
          ],
          pedidos: [{
                    name: 'María Perez',
                    calories: 159,
                    fat: 6.0,
                    carbs: 24,
                    protein: 4.0,
                    iron: '1%',
                    telefono: '669-1598865',
                    precio: '300',
                },
                {
                    name: 'Pedro Perez',
                    calories: 518,
                    fat: 26.0,
                    carbs: 65,
                    protein: 7,
                    iron: '6%',
                    telefono: '669-1598865',
                    precio: '300',
                },
          ],
          telefono: null,
          field_nombre_cli: 'Jane',
          field_apellidos_cli: 'Doe',
          field_telefono_cli: '669199865',
          field_email_cli: 'm1_20@hotmail.com',
          createClienteDialog: false,
          customToken: null,
          showLoader: false,
          phoneNotUnique: false,
          searchResults: [],
          searchingTel: false,
          pedidoDialog: false,
          clienteStepper: 1,
          calle: '',
          colonia: '',
          codigo_postal: '',
          ciudad: 'Mazatlán',
          estado: 'Sinaloa',
          observaciones: '',
          lat: null,
          lng: null,
          foundAddress: [],
          formattedAddress: '',
          selectedCliente: null,
          direcciones: [],
          loadingDirecciones: false,
          loadingCliente: false,
          selected_address: null,
          selected_client_nid: null,
          orders: [],
          loadingOrders: true,
          orderDialog: false,
          selectedOrder: null,
          procesos: [
            {value: 'montaje', key: 'Área de Montaje'},
            {value: 'horno', key: 'en el Horno'},
            {value: 'rumbo', key: 'Rumbo a Casa'},
            {value: 'entregado', key: 'Entregado'},
            {value: 'cancelado', key: 'Cancelado'},
          ],
          statusUpdate: false,
          selectedEstado: null
        }
    },
    mounted() {
      // db.collection("telefonos")
      // .doc("vgbqLlbQxVBFj8I55lbk")
      // .get()
      // .then(snapshot => {
      //   console.log(snapshot.data())
      // })
    },
    created() {
      //Load Settings
      this.getConfigVariable('google_maps_api_key')
      .then(res => {
        this.$store.commit('setGoogleAPIKey', res.data[0])
      })
      //Get Orders
      this.getOrders()
      .then(res => {
        console.log(res.data)
        this.loadingOrders = false
        this.orders = res.data
      })
      //Subscribe to Real Time Events
      this.pusherSubscriber()
    },
    methods: {
      newOrder() {
        this.dialog_pedido = true
        this.$store.commit('resetOrder')
      },
      selectCliente(nid) {
        this.$store.commit('openPedidoDialog')
        this.selected_client_nid = nid
      },
      buscarTelefono() {
        if(this.$refs.form_search_tel.validate()) {
          //console.log('Buscando', this.telefono)
          this.searchingTel = true
          axios.get(this.$store.state.astilleroURL + '/api/views/buscar_telefonos?display_id=services_1&combine=' + this.telefono, {
            headers: {
              'Content-Type': 'application/json',
              'X-Cookie': this.$store.state.user.session_name + '=' + this.$store.state.user.sessid,
              'X-CSRF-Token': this.$store.state.token
            }
          })
          .then(res => {
            //console.log(res.data)
            this.searchingTel = false
            this.searchResults = res.data
          })
          .catch(error => {
            console.log(error)
            this.searchingTel = false
          })
        }
      },
      nextStep() {
        if(this.$refs.create_cliente_form.validate()) {
          this.clienteStepper = 2
        }
      },
      cancelCliente() {
        this.createClienteDialog = false
        this.clienteStepper = 1
      },
      saveCliente() {
        this.showLoader = true
        this.phoneNotUnique = false
        const data = {
          type: 'clientes',
          field_nombre_cli: {und: [{value: this.field_nombre_cli}]},
          field_apellidos_cli: {und: [{value: this.field_apellidos_cli}]},
          field_telefono_cli: {und: [{value: this.field_telefono_cli}]},
          field_email_cli: {und: [{value: this.field_email_cli}]},
        }
        
        axios.get(this.$store.state.astilleroURL + '/api/views/services_verify_phone?display_id=services_1&args[0]=' + this.field_telefono_cli, {
          headers: {
            'Content-Type': 'application/json',
            'X-Cookie': this.$store.state.user.session_name + '=' + this.$store.state.user.sessid,
            'X-CSRF-Token': this.$store.state.token
          }
        })
        .then(res => {
          //check if phone exists
          if(res.data.length > 0) {
            this.phoneNotUnique = true
            this.showLoader = false
          }
          else {
            if(this.$refs.create_cliente_form.validate()) {
              this.setCookieToken()
              .then(() => {
                this.createNode(data)
                .then(res => {
                  this.showLoader = false
                  //this.createClienteDialog = false
                  //console.log(res.data)
                  this.clienteStepper = 2
                  this.$store.commit('setClient', res.data.nid)
                })
                .catch(error => {
                  //this.createClienteDialog = false
                  this.showLoader = false
                  console.log(error)
                })
              })
            }
          }
        })
        .catch(error => console.log(error))
      },
      saveDireccion() {
        if(this.$refs.direccion_form.validate()) {
          this.showLoader = true
          //console.log('Saving address')
          axios.get('https://maps.googleapis.com/maps/api/geocode/json?address=' + this.calle + '+' + this.colonia + '+' + this.ciudad + '&key=' + this.$store.state.apiKey)
          .then(res => {
            //console.log(res.data.results)
            //console.log('Coords', res.data.results[0].geometry)
            this.foundAddress = res.data.results
            this.formattedAddress = res.data.results[0].formatted_address
            this.lat = res.data.results[0].geometry.location.lat
            this.lng = res.data.results[0].geometry.location.lng
            //this.showLoader = false
            const data = {
              type: 'direccion_de_los_clientes',
              field_cliente_dir: {
                und: [{
                    target_id: this.field_nombre_cli + ' ' + this.field_apellidos_cli + ' (' + this.$store.state.selected_client_nid  + ')'
                  }]
              },
              field_calle_dir: {und: [{value: this.calle}]},
              field_colonia_dir: {und: [{value: this.colonia}]},
              field_ciudad_dir: {und: [{value: this.ciudad}]},
              field_estado_dir: {und: [{value: this.estado}]},
              field_formatted_dir: {und: [{value: this.formattedAddress}]},
              field_lat_dir: {und: [{value: this.lat}]},
              field_long_dir: {und: [{value: this.lng}]},
            }
             this.setCookieToken()
            .then(() => {
              this.createNode(data)
              .then(res => {
                this.showLoader = false
                this.createClienteDialog = false
                //console.log(res.data)
                this.clienteStepper = 1
                this.$store.commit('setAddress', res.data.nid)
              })
              .catch(error => {
                this.createClienteDialog = false
                this.showLoader = false
                console.log(error)
              })
            })
          })
          .catch(error => console.log(error))
        }
      },
      pickupOrder() {
        this.createClienteDialog = false
        this.$store.commit('setOrderType', 'Pickup')
      },
      orderCompleted() {
        this.dialog_pedido = false
      },
      selectOrder(item) {
        console.log(item)
        this.orderDialog = true
        this.selectedOrder = item
      },
      updateStatus(item){
        this.orderDialog = false
        this.statusUpdate = false
        //this.selectedOrder.Estado = this.selectedEstado
        const data = {
          order_nid: item.Nid,
          cliente_nid: item.cliente_nid,
          user_uid: this.getCurrentUser.user.uid,
          order_status: this.selectedEstado
        }
        this.updateOrderStatus(data)
        .then(res => {
          console.log(res)
        })
      },
      pusherSubscriber() {
        console.log('Real time data ready')
        channel.bind('order-events', data => {
          console.log(data.message)
          //Reload Orders
          this.getOrders()
          .then(res => {
            this.loadingOrders = false
            this.orders = res.data
          })
        })
      },
    },
    computed: {
      ...mapGetters([
        'getSelectedClient',
        'getSelectedAddress',
        'getOrderType',
        'getSelectedProducts',
        'getTotalOrder',
        'getCurrentUser'
      ])
    }
}
</script>

<style>
  .Proceso {
    background-color: #039BE5 !important;
  }
</style>
